import { Building, LayoutDashboard, Settings } from "lucide-react";

const superAdminNavigation = [
  {
    key: "/org/dashboard",
    icon: <LayoutDashboard className="icon" />,
    label: "Dashboard",
    navigate: "/org/dashboard",
  },
  {
    key: "/tenant",
    icon: <Building className="icon" />,
    label: "Tenant",
    navigate: "/tenant",
  },
  {
    key: "/setting",
    icon: <Settings className="icon" />,
    label: "Settings",
    navigate: "/setting",
  }
];


export default superAdminNavigation;